import axios from "axios";
import context from '../main.js'

const service = axios.create({
    // baseURL: '',  // api的base_url
    // withCredentials: true,
    timeout: 60000 // 请求超时时间
});

function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null;
}
function setCookie(cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + '; ' + expires + '; ' + 'path=/'
}

const _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

const _utf8_encode = function(string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";
    for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);
        if (c < 128) {
            utftext += String.fromCharCode(c);
        } else if ((c > 127) && (c < 2048)) {
            utftext += String.fromCharCode((c >> 6) | 192);
            utftext += String.fromCharCode((c & 63) | 128);
        } else {
            utftext += String.fromCharCode((c >> 12) | 224);
            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
            utftext += String.fromCharCode((c & 63) | 128);
        }
    }
    return utftext;
}
const encode = function(input) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = _utf8_encode(input);
    while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
            enc4 = 64;
        }
        output = output +
            _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
            _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
    }
    return output;
}

// service.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8';
service.interceptors.request.use(config => {
    if (config.url.includes('userId=') || config.url.includes('storeId=') || config.url.includes('fbxuanpin.ant3r.com') || config.url.includes('cod.antfactory.com.cn')|| config.url.includes('cod.antfactory.com.cn')) {
      config.headers['X-Referer'] = window.location.origin
    }
    //let token=localStorage.getItem("token")
    let cookie = getCookie('Authorization')
    let token = cookie || localStorage.getItem("token")
    let userId = localStorage.getItem("userId")
    let realName = localStorage.getItem("realName")

    // 在发送请求之前做些什么
    if (token) {
        config.headers['Authorization'] = token;
    }
    if (config.url.indexOf('gateway.di79.com/account-service') > -1) {
      if (userId) config.headers['x-auth-user-id'] = userId;
      if (realName) config.headers['x-auth-user-name'] = encode(realName);
    }
    if (config.url.indexOf('gateway.antdiy.vip/account-service') > -1) {
      if (userId) config.headers['x-auth-user-id'] = userId;
      if (realName) config.headers['x-auth-user-name'] = encode(realName);
    }
    if (config.url.indexOf('gateway.di79.com/message-automation') > -1) {
      if (userId) config.headers['x-auth-user-id'] = userId;
      if (realName) config.headers['x-auth-user-name'] = encode(realName);
    }
    if (config.url.indexOf('gateway.antdiy.vip/message-automation') > -1) {
      if (userId) config.headers['x-auth-user-id'] = userId;
      if (realName) config.headers['x-auth-user-name'] = encode(realName);
    }
    if (config.url.indexOf('gateway.di79.com/product-service') > -1) {
        if (userId) config.headers['x-auth-user-id'] = userId;
        if (realName) config.headers['x-auth-user-name'] = encode(realName);
    }
    if (config.url.indexOf('gateway.antdiy.vip/product-service') > -1) {
      if (userId) config.headers['x-auth-user-id'] = userId;
      if (realName) config.headers['x-auth-user-name'] = encode(realName);
    }
    if (config.url.indexOf('orderdev.antfactory.com.cn/antdiy') > -1) {
      if (userId) config.headers['x-auth-user-id'] = userId;
      if (realName) config.headers['x-auth-user-name'] = encode(realName);
    }
    if (config.url.indexOf('order.antfactory.com.cn/antdiy') > -1) {
      if (userId) config.headers['x-auth-user-id'] = userId;
      if (realName) config.headers['x-auth-user-name'] = encode(realName);
    }
    window._axiosPromiseArr = []
    config.cancelToken = new axios.CancelToken(cancel => {
        window._axiosPromiseArr.push({ cancel })
    })
    return config;
}, error => { //请求错误处理

    Promise.reject(error)
});

service.interceptors.response.use(
    response => {
        if (response.data && response.data.user && response.data.user.token) {
            let storage = response.data.user.token;
            localStorage.setItem("token", storage)
            localStorage.setItem("realName", response.data.user.real_name)
            localStorage.setItem('menuList', response.data.user.menu_list ? JSON.stringify(response.data.user.menu_list) : '')
            try {
              setCookie('realName', response.data.user.real_name, 30)
            } catch (error) {
              
            }
        }
        if (response.data.code == '1001002' || response.data.code == '1001000') {
            //vue.$router.push({path:'/'})
            localStorage.removeItem('token')
            context.$router.push('/')
        }
        if (response.data.code == '1001200') {
            //vue.$router.push({path:'/'})
            context.$message.error("无资金账户")
        }
        if (response.data.code == '1001201') {
            //vue.$router.push({path:'/'})
            context.$message.error("可用资金不足")
        }
        return response
    },
    error => {
      if (error.response && error.response.data.code == '1001000') {
        localStorage.removeItem('token')
        context.$router.push('/')
        return
      }
      return Promise.reject(error)
    }
);

export default service